.imageContainer {
  text-transform: uppercase;
  text-decoration: none;
  background-color: var(--color-background-tertiary);
}

.image {
  object-fit: cover;
  border-radius: var(--border-radius-1);
}

.documentFileName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
